import { render, staticRenderFns } from "./txzl.vue?vue&type=template&id=61744ea1&scoped=true"
import script from "./txzl.vue?vue&type=script&lang=js"
export * from "./txzl.vue?vue&type=script&lang=js"
import style0 from "./txzl.vue?vue&type=style&index=0&id=61744ea1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61744ea1",
  null
  
)

export default component.exports